module.exports = __webpack_public_path__ + "img/hand_hold.07453470.jpg";